// Vendor
import { ElementRef } from '@angular/core';
// Services
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import { SecuritiesService } from 'SecuritiesApp/ts/services/securities.service';
// Components
import { ComparablesModalComponent } from 'SecuritiesApp/ts/features/comparables-modal/comparables-modal.component';
import { ALL_HOLDINGS, FLATTENED_HOLDINGS, HOLDINGS, INTERSECT_ALL_HOLDINGS, INTERSECT_COMMON_HOLDINGS, INTERSECT_UNIQUE_HOLDINGS, } from 'SecuritiesApp/ts/constants/holdings-table.constants';
import { INDEX, MODEL_PORTFOLIO, MUTUAL_FUND, COMPANY_FUND, COMPANY } from 'NewAngular/constants/core.constants';
import { ALL_FUND_HOLDINGS_FEATURE } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import { DIRECT_HOLDINGS, UNDERLYING_HOLDINGS, INVESTED_HOLDINGS } from 'ModelPortfolioApp/ts/shared/constants';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { getHoldingsLayerUserPreferenceKey } from 'NewAngular/utils/security-utils';
import * as i0 from "@angular/core";
import * as i1 from "SecuritiesApp/ts/services/securities.service";
import * as i2 from "AccountsApp/ts/services/accounts.service";
import * as i3 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i4 from "@angular/common";
import * as i5 from "../comparables-modal/comparables-modal.component";
import * as i6 from "../holdings-comparison-table/holdings-comparison-table.component";
import * as i7 from "../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i8 from "@angular/forms";
import * as i9 from "../../../../../../../ycharts/static/ts/features/components/dropdowns/single-select-dropdown/single-select-dropdown.component";
const _c0 = () => ({ button: "btn btn-secondary dropdown-toggle" });
const _c1 = () => ({ button: "btn btn-block btn-secondary dropdown-toggle", dropdownMenu: "dropdown-menu-right" });
function HoldingsComparisonComponent_ycn_single_select_dropdown_6_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-single-select-dropdown", 10);
    i0.ɵɵlistener("changeHandler", function HoldingsComparisonComponent_ycn_single_select_dropdown_6_Template_ycn_single_select_dropdown_changeHandler_0_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.updateHoldingsLayer($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("customCssClasses", i0.ɵɵpureFunction0(3, _c1))("config", ctx_r1.HOLDINGS_LAYER_DROPDOWN_CONFIG)("selectedValue", ctx_r1.selectedHoldingsLayer);
} }
function HoldingsComparisonComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14)(1, "label", 15)(2, "input", 16);
    i0.ɵɵlistener("change", function HoldingsComparisonComponent_div_7_Template_input_change_2_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.updateBenchmarkPreference()); });
    i0.ɵɵtwoWayListener("ngModelChange", function HoldingsComparisonComponent_div_7_Template_input_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r1.showBenchmark, $event) || (ctx_r1.showBenchmark = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "span", 17);
    i0.ɵɵelementStart(4, "span", 18);
    i0.ɵɵtext(5, "Show Benchmark Comparison");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.showBenchmark);
} }
function HoldingsComparisonComponent_ng_container_15_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21)(1, "ycn-holdings-comparison-table", 22);
    i0.ɵɵlistener("removeComparableHandler", function HoldingsComparisonComponent_ng_container_15_div_1_Template_ycn_holdings_comparison_table_removeComparableHandler_1_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.removeComparableHandler($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const comparable_r5 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("type", ctx_r1.holdingsType)("comparable", comparable_r5)("disableRemoveFromMenu", comparable_r5.securityId === ctx_r1.currentSecurityComparable.securityId)("intersectOption", ctx_r1.comparableHoldingsIntersectionOption)("comparableSecurities", ctx_r1.comparableSecurities)("holdingsLayer", ctx_r1.selectedHoldingsLayer);
} }
function HoldingsComparisonComponent_ng_container_15_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 23)(1, "div", 24);
    i0.ɵɵlistener("click", function HoldingsComparisonComponent_ng_container_15_div_2_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r6); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.openComparablesModal()); });
    i0.ɵɵelementStart(2, "div", 25);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(3, "svg", 26);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5, "Add Comparables");
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("name", "icon-shape-cross");
} }
function HoldingsComparisonComponent_ng_container_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, HoldingsComparisonComponent_ng_container_15_div_1_Template, 2, 6, "div", 19)(2, HoldingsComparisonComponent_ng_container_15_div_2_Template, 6, 1, "div", 20);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.comparableSecurities)("ngForTrackBy", ctx_r1.trackBySecurityId);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.comparableSecurities.length < ctx_r1.totalSecurities());
} }
/**
 * HoldingsOverlapComparisonComponent.
 *
 * Panes with holdings information for editable comparables. It contains buttons to add more panes to compare
 * other securities.
 * Required Attributes:
 *      @ security: `SerializedSecurityObjectInfo` object with the current security.
 *      @ benchmarkSecurity: `SerializedSecurityObjectInfo` object with the benchmark security.
 *      @ pageTitle: Page title with the name of the security.
 *      @ relatedSecuritySearchType: Search type associated to the security type.
 *      @ relatedSecurities: Related securities set by the user.
 */
export class HoldingsComparisonComponent {
    constructor(eltRef, securitiesService, accountsService, featuresService) {
        this.eltRef = eltRef;
        this.securitiesService = securitiesService;
        this.accountsService = accountsService;
        this.featuresService = featuresService;
        // Constants
        this.MAX_COMPARABLES = 6;
        this.MAX_DISPLAY_COMPARABLES = 3;
        this.COMPARABLES_HOLDINGS_INTERSECTION_CONFIG = {
            list: [
                { value: INTERSECT_ALL_HOLDINGS, label: 'All Holdings' },
                { value: INTERSECT_COMMON_HOLDINGS, label: 'Common Holdings' },
                { value: INTERSECT_UNIQUE_HOLDINGS, label: 'Unique Holdings' },
            ],
        };
        // Data & flags
        this.comparableSecurities = [];
        this.relatedSecurities = [];
        this.modalText = '';
        this.comparableHoldingsIntersectionOption = null;
        this.HOLDINGS_LAYER_DROPDOWN_CONFIG = {
            list: [
                { value: DIRECT_HOLDINGS, label: 'Holdings' },
                { value: UNDERLYING_HOLDINGS, label: 'Underlying Holdings' },
            ],
        };
        this.selectedHoldingsLayer = DIRECT_HOLDINGS;
        this.isFundOfFunds = false;
        this.hasNestedModelPortfolios = false;
        this.showHoldingsLayerSelection = false;
        this.originalType = FLATTENED_HOLDINGS;
        this.holdingsType = eltRef.nativeElement.getAttribute('holdingsType');
        this.isFundOfFunds = eltRef.nativeElement.getAttribute('isFundOfFunds') === 'True';
        this.hasNestedModelPortfolios = eltRef.nativeElement.getAttribute('hasNestedModelPortfolios') === 'True';
        // Show T25 Fund Holdings if user does not have all holdings feature
        if (this.holdingsType === ALL_HOLDINGS && !this.featuresService.userHasFeatures([ALL_FUND_HOLDINGS_FEATURE]))
            this.holdingsType = HOLDINGS;
        this.securityType = eltRef.nativeElement.getAttribute('securityType');
        this.pageTitle = eltRef.nativeElement.getAttribute('pageTitle');
        this.showRestoreComparablesDefaults =
            eltRef.nativeElement.getAttribute('showRestoreComparablesDefaults') === 'true';
        this.relatedSecuritySearchType = eltRef.nativeElement.getAttribute('relatedSecuritySearchType');
        this.relatedSecurities = this.castSerializedRelatedSecurities(JSON.parse(eltRef.nativeElement.getAttribute('relatedSecurities')));
        this.currentSecurityComparable = this.castSerializedRelatedSecurity(JSON.parse(eltRef.nativeElement.getAttribute('security')));
        this.benchmarkSecurity = this.castSerializedRelatedSecurity(JSON.parse(eltRef.nativeElement.getAttribute('benchmarkSecurity')));
        this.benchmarkIsIndex = this.benchmarkSecurity.securityType === INDEX;
        this.showBenchmark = !this.benchmarkIsIndex; // If benchmark is index, we don't want to show it
        this.getBenchmarkPreference();
        this.showHoldingsLayerSelection =
            this.securityType != null &&
                [COMPANY_FUND, MUTUAL_FUND, MODEL_PORTFOLIO].includes(this.securityType) &&
                (this.hasNestedModelPortfolios || this.isFundOfFunds);
        if (this.hasNestedModelPortfolios) {
            this.HOLDINGS_LAYER_DROPDOWN_CONFIG.list.splice(1, 0, {
                value: INVESTED_HOLDINGS,
                label: 'Invested Holdings',
            });
        }
        this.originalType = this.holdingsType;
    }
    ngOnInit() {
        this.modalText = `Drag and drop to reorder or search security to add. Only top ${this.MAX_DISPLAY_COMPARABLES} 
            comparables are shown. Please note that index items will not be displayed on this page.`;
        this.accountsService.getUserPreferences().subscribe((preference) => {
            this.comparableHoldingsIntersectionOption = preference.comparables_holdings_intersection_option;
            if (this.showHoldingsLayerSelection) {
                this.selectedHoldingsLayer = this.getDefaultSelectedHoldingsLayer(preference);
                if (this.selectedHoldingsLayer !== DIRECT_HOLDINGS) {
                    this.holdingsType = FLATTENED_HOLDINGS;
                }
            }
        });
    }
    /**
     * Handler for the edit comparables event.
     *
     * @param relatedSecurities: New list of related securities.
     */
    editComparablesSubmitHandler(relatedSecurities) {
        this.comparablesModalComponent.closeModal();
        this.relatedSecurities = relatedSecurities;
        this.setComparablesSecuritiesList(relatedSecurities);
    }
    /**
     * Opens the comparables modal.
     */
    openComparablesModal() {
        this.comparablesModalComponent.openModal();
    }
    updateHoldingsLayer(layerSelection) {
        this.selectedHoldingsLayer = layerSelection;
        if (layerSelection !== DIRECT_HOLDINGS) {
            this.holdingsType = FLATTENED_HOLDINGS;
        }
        else {
            this.holdingsType = this.originalType;
        }
        const userPreferenceKey = getHoldingsLayerUserPreferenceKey(this.securityType);
        if (userPreferenceKey) {
            this.accountsService.putUserPreferencesAndRefreshCache({ [userPreferenceKey]: this.selectedHoldingsLayer });
        }
    }
    getDefaultSelectedHoldingsLayer(userPreferences) {
        const securityHoldingsLayerSelectionMap = {
            [COMPANY]: userPreferences.company_fund_holdings_layer_selection ?? DIRECT_HOLDINGS,
            [COMPANY_FUND]: userPreferences.company_fund_holdings_layer_selection ?? DIRECT_HOLDINGS,
            [MODEL_PORTFOLIO]: userPreferences.model_portfolio_holdings_layer_selection ?? DIRECT_HOLDINGS,
            [MUTUAL_FUND]: userPreferences.mutual_fund_holdings_layer_selection ?? DIRECT_HOLDINGS,
        };
        const holdingsLayer = securityHoldingsLayerSelectionMap[this.securityType] ?? DIRECT_HOLDINGS;
        if (!this.HOLDINGS_LAYER_DROPDOWN_CONFIG.list.map((option) => option.value).includes(holdingsLayer)) {
            return DIRECT_HOLDINGS;
        }
        return holdingsLayer;
    }
    /**
     * Track by helper method.
     *
     * @param index: Index number.
     * @param security: Security at the given index.
     */
    trackBySecurityId(index, security) {
        return security.securityId;
    }
    /**
     * Converts a list of SerializedSecurityObjectInfo into a list of SerializedSecurityObjectInfo objects.
     * @param securities: List of SerializedSecurityObjectInfo objects.
     */
    castSerializedRelatedSecurities(securities) {
        return securities.map(this.castSerializedRelatedSecurity);
    }
    /**
     * Transform a SerializedSecurityObjectInfo object into SerializedRelatedSecurity instance.
     *
     * @param security: SerializedSecurityObjectInfo object
     * @private
     */
    castSerializedRelatedSecurity(security) {
        return {
            displaySecurityId: security.display_security_id,
            securityId: security.security_id,
            name: security.security_name,
            securityType: security.security_type,
        };
    }
    /**
     * Helper function to set the value for `comparableSecurities`.
     *
     * The function limit the comparables total securities and **after that** it gets rid of the index securities.
     *
     * @param relatedSecurities: Related securities to add to comparableSecurities.
     */
    setComparablesSecuritiesList(relatedSecurities) {
        const baseComparables = [this.currentSecurityComparable];
        if (this.showBenchmark)
            baseComparables.push(this.benchmarkSecurity);
        this.comparableSecurities = [...baseComparables, ...relatedSecurities]
            .slice(0, this.totalSecurities())
            .filter((s) => s.securityType !== INDEX);
    }
    /**
     * Helper function to determine the total number of shown securities.
     */
    totalSecurities() {
        // Add 1 to account for base security, and another for when benchmark is shown
        return this.MAX_DISPLAY_COMPARABLES + 1 + (this.showBenchmark ? 1 : 0);
    }
    /**
     * Removes a comparable from `comparableSecurities`. Resets the original list for ComparablesModalComponent.
     *
     * @param comparable: Comparable to be removed.
     */
    removeComparableHandler(comparable) {
        this.relatedSecurities = this.relatedSecurities.filter((security) => security.securityId !== comparable.securityId);
        this.setComparablesSecuritiesList(this.relatedSecurities);
        const newRelatedSecurities = this.relatedSecurities.map((sec) => sec.securityId);
        this.securitiesService
            .putUserRelatedSecurities(this.currentSecurityComparable.securityId, newRelatedSecurities)
            .subscribe();
        this.comparablesModalComponent.setOriginalRelatedSecurities(this.relatedSecurities);
    }
    /**
     * Get the preference name, depending on the security type and the view.
     *
     * @private
     */
    getPreference() {
        const app = this.holdingsType === FLATTENED_HOLDINGS ? 'holdings_overlap' : 'holdings';
        const preference = `${this.securityType}_${app}_include_benchmark`;
        return preference;
    }
    /**
     * Get the user preference from the server.
     *
     * @private
     */
    getBenchmarkPreference() {
        if (this.benchmarkIsIndex) {
            this.setComparablesSecuritiesList(this.relatedSecurities);
            return;
        }
        this.accountsService.getUserPreferences().subscribe((preferences) => {
            const preference = this.getPreference();
            this.showBenchmark = preferences[preference];
            this.setComparablesSecuritiesList(this.relatedSecurities);
        });
    }
    /**
     * Update the user preference in the server.
     */
    updateBenchmarkPreference() {
        if (this.benchmarkIsIndex)
            return;
        const preference = this.getPreference();
        const newPreferenceRequest = {};
        newPreferenceRequest[preference] = this.showBenchmark; // showBenchmark is already updated
        this.accountsService.putUserPreferences(newPreferenceRequest).subscribe({
            next: () => {
                this.setComparablesSecuritiesList(this.relatedSecurities);
            },
            error: () => {
                this.showBenchmark = !this.showBenchmark;
            },
        });
    }
    /**
     * Update the intersection option.
     */
    updateComparableHoldingsIntersectionOption(intersectionSelection) {
        this.comparableHoldingsIntersectionOption = intersectionSelection;
        this.accountsService
            .putUserPreferences({ comparables_holdings_intersection_option: this.comparableHoldingsIntersectionOption })
            .subscribe({
            next: () => { },
            error: () => { },
        });
    }
}
HoldingsComparisonComponent.ɵfac = function HoldingsComparisonComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || HoldingsComparisonComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.SecuritiesService), i0.ɵɵdirectiveInject(i2.AccountsService), i0.ɵɵdirectiveInject(i3.FeatureService)); };
HoldingsComparisonComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HoldingsComparisonComponent, selectors: [["ycn-holdings-comparison"]], viewQuery: function HoldingsComparisonComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(ComparablesModalComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.comparablesModalComponent = _t.first);
    } }, standalone: false, decls: 17, vars: 17, consts: [[1, "row", "page-header"], [1, "col"], [1, "page-title"], [1, "page-name", 3, "textContent"], [1, "col-auto", "page-header-actions"], [3, "customCssClasses", "config", "selectedValue", "changeHandler", 4, "ngIf"], ["class", "page-header-action align-items-center form-inline", 4, "ngIf"], [1, "page-header-action", 2, "padding-left", "10px"], [1, "btn", "btn-transparent2", 3, "click"], ["ycnIcon", "", 3, "name"], [3, "changeHandler", "customCssClasses", "config", "selectedValue"], [1, "row", "panels-row"], [4, "ngIf"], [3, "submitHandler", "benchmarkSecurityId", "maxComparables", "maxDisplayComparables", "relatedSecurities", "securityId", "searchType", "showRestoreDefaults", "modalText"], [1, "page-header-action", "align-items-center", "form-inline"], [1, "custom-control", "custom-checkbox"], ["type", "checkbox", 1, "custom-control-input", 3, "change", "ngModelChange", "ngModel"], [1, "custom-control-indicator"], [1, "custom-control-description"], ["class", "col-6 ng-scope", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["class", "col-6", 4, "ngIf"], [1, "col-6", "ng-scope"], [3, "removeComparableHandler", "type", "comparable", "disableRemoveFromMenu", "intersectOption", "comparableSecurities", "holdingsLayer"], [1, "col-6"], [1, "panel", "get-started-panel", 3, "click"], [1, "panel-subtitle"], ["ycnIcon", "", 1, "panel-subtitle-icon", 3, "name"]], template: function HoldingsComparisonComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
        i0.ɵɵelement(3, "div", 3);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(4, "div", 4)(5, "div", 4);
        i0.ɵɵtemplate(6, HoldingsComparisonComponent_ycn_single_select_dropdown_6_Template, 1, 4, "ycn-single-select-dropdown", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(7, HoldingsComparisonComponent_div_7_Template, 6, 1, "div", 6);
        i0.ɵɵelementStart(8, "div", 7)(9, "span", 8);
        i0.ɵɵlistener("click", function HoldingsComparisonComponent_Template_span_click_9_listener() { return ctx.openComparablesModal(); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(10, "svg", 9);
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(11, "span");
        i0.ɵɵtext(12, "Edit Comparables");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(13, "ycn-single-select-dropdown", 10);
        i0.ɵɵlistener("changeHandler", function HoldingsComparisonComponent_Template_ycn_single_select_dropdown_changeHandler_13_listener($event) { return ctx.updateComparableHoldingsIntersectionOption($event); });
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(14, "div", 11);
        i0.ɵɵtemplate(15, HoldingsComparisonComponent_ng_container_15_Template, 3, 3, "ng-container", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "ycn-comparables-modal", 13);
        i0.ɵɵlistener("submitHandler", function HoldingsComparisonComponent_Template_ycn_comparables_modal_submitHandler_16_listener($event) { return ctx.editComparablesSubmitHandler($event); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("textContent", ctx.pageTitle);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.showHoldingsLayerSelection);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.benchmarkIsIndex);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("name", "icon-shape-cross");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("customCssClasses", i0.ɵɵpureFunction0(16, _c0))("config", ctx.COMPARABLES_HOLDINGS_INTERSECTION_CONFIG)("selectedValue", ctx.comparableHoldingsIntersectionOption);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.comparableHoldingsIntersectionOption !== null);
        i0.ɵɵadvance();
        i0.ɵɵproperty("benchmarkSecurityId", ctx.benchmarkSecurity.securityId)("maxComparables", ctx.MAX_COMPARABLES)("maxDisplayComparables", ctx.MAX_DISPLAY_COMPARABLES)("relatedSecurities", ctx.relatedSecurities)("securityId", ctx.currentSecurityComparable.securityId)("searchType", ctx.relatedSecuritySearchType)("showRestoreDefaults", ctx.showRestoreComparablesDefaults)("modalText", ctx.modalText);
    } }, dependencies: [i4.NgForOf, i4.NgIf, i5.ComparablesModalComponent, i6.HoldingsComparisonTableComponent, i7.IconDirective, i8.CheckboxControlValueAccessor, i8.NgControlStatus, i8.NgModel, i9.SingleSelectDropdownComponent], encapsulation: 2 });
